<template>
  <sdz-modal
    ref="sdzModal"
    :title="title"
    :confirm-button-label="'ok, entendi'"
    :confirmation-event="'onConfirm'"
    @close="close"
    @onConfirm="onConfirm"
    width="550"
    hide-cancel-button
    persistent
    buttons-position="right"
    close-icon
  >
    <div class="sales-information">
      <div>
        <p>
          Os dados de vendas exibidos nesta tela ainda não foram validados pelo parceiro gestor da campanha e, portanto, não estão finalizados.
          Para que os dados sejam considerados válidos e oficiais, é necessário que passem pelas seguintes etapas de aprovação:
        </p>
      </div>
      <div>
        <ol>
          <li>Validação do Responsável Legal: A equipe interna do canal revisará os dados para garantir sua precisão e completude.</li>
          <li>Validação da Indústria: Os dados serão enviados para a indústria para validação e confirmação.</li>
        </ol>
      </div>
      <div>
        <p>
          Durante o processo de aprovação, os dados podem estar sujeitos a alterações. <br>Recomendamos que você:
        </p>
      </div>
      <div>
        <ul>
          <li>Não utilize esses dados como base para decisões finais.</li>
          <li>Aguarde a aprovação final antes de compartilhar esses dados com terceiros.</li>
          <li>Verifique esta tela novamente após a conclusão do processo de aprovação para obter os dados finais.</li>
        </ul>
      </div>
    </div>
  </sdz-modal>
</template>

<script>
export default {
  name: 'SalesInformationModal',

  components: {
    SdzModal: () => import('@/components/sdz/SdzModal.vue'),
  },

  props: {
    alertType: {
      type: String,
      default: () => 'warning'
    },
    title: {
      type: String,
      default: () => 'Atenção'
    },
  },

  data: () => ({

  }),

  methods: {
    open() {
      this.$refs.sdzModal.show = true
    },
    close() {
      this.$refs.sdzModal.show = false
    },
    onConfirm() {
      this.close()
    }
  }
}
</script>

<style lang="stylus" scoped>
.sales-information
  padding: 30px
  p, ol, ul
    color: var(--v-primary-base)
    font-weight: 500
</style>
